import { useDataState } from "./data";

export const useStrategies = () => {
  const strategies = useDataState().strategies;

  const getStrategyById = (strategyId?: number) => {
    if (!strategyId) return undefined;
    return strategies.find((strategy) => strategy.id === strategyId);
  };

  const getStrategyName = (strategyId: number) => {
    return strategies.find((strategy) => strategy.id === strategyId)?.name || strategyId.toString();
  };

  const getStrategyDescription = (strategyId: number) => {
    const strategy = strategies.find((strategy) => strategy.id === strategyId);
    return strategy?.description || strategy?.name || strategyId.toString();
  };

  return {
    strategies,
    getStrategyById,
    getStrategyName,
    getStrategyDescription,
  };
};
